export { RoomRateConfigurationWizardV2 as RoomRateConfigurationWizard } from './v2';
